// 메일 변수/스니펫 토큰 정규식 — 백엔드 app/module/_mail_template.py 의
// VAR_PATTERN / SNIPPET_PATTERN / KWARG_PATTERN 과 "문자 단위로 동일한" 단일 소스.
//
// WYSIWYG 편집기는 로드 시 이 정규식으로 토큰을 비편집 칩으로 바꾸고, 저장 전
// idempotent 가드로 왕복 무결성을 검사한다. 프론트 칩 정규식이 백엔드 치환 정규식과
// 어긋나면 오매칭(백엔드만 변수)·누락(프론트만 칩)·과매칭이 생기므로, 이 파일은
// 백엔드와 반드시 동일해야 한다.
//
// ⛔ 백엔드 정규식이 바뀌면 이 파일도 함께 바꿀 것.
// node:test 단위 테스트 + webpack 빌드 양쪽에서 쓰기 위해 CommonJS 로 작성한다.
//
// 백엔드 원문(참고):
//   SNIPPET_PATTERN = r'\{\{%\s*snippet\s+(.*?)%\}\}'
//   VAR_PATTERN     = r'\{\{\s*(?:(\w+)\s+)?(\w+(?:\.\w+)*)((?:\s+\w+=["\'][^"\']+["\'])*)\s*\}\}'
//   KWARG_PATTERN   = r'(\w+)=["\']([^"\']+)["\']'
//
// 주의(파이썬 ↔ JS \w 차이): 파이썬 re 의 \w 는 유니코드(한글 포함), JS 의 \w 는
// ASCII([A-Za-z0-9_])다. 변수 키(group.field)는 모델 컬럼명이라 전부 ASCII 이므로
// 실무상 차이가 없다. 스니펫 코드는 (.*?) 로 잡으므로 하이픈(qesg-name-card)도 포함된다.

// /g 정규식은 재사용 시 lastIndex 상태를 갖는다. 매 호출마다 새로 만들어 상태를 격리한다.
function snippetRe() {
    return /\{\{%\s*snippet\s+(.*?)%\}\}/g
}
function varRe() {
    return /\{\{\s*(?:(\w+)\s+)?(\w+(?:\.\w+)*)((?:\s+\w+=["'][^"']+["'])*)\s*\}\}/g
}
function kwargRe() {
    return /(\w+)=["']([^"']+)["']/g
}

// text 안의 모든 변수 토큰. 각 항목: { full, type|null, key, kwargsRaw, index, length }
function findVarMatches(text) {
    const out = []
    if (!text) return out
    const re = varRe()
    let m
    while ((m = re.exec(text)) !== null) {
        // zero-length 매칭 방어(정상적으로는 발생하지 않으나 무한루프 예방)
        if (m.index === re.lastIndex) { re.lastIndex++; continue }
        out.push({
            full: m[0],
            type: m[1] || null,
            key: m[2],
            kwargsRaw: m[3] || '',
            index: m.index,
            length: m[0].length,
        })
    }
    return out
}

// text 안의 모든 스니펫 토큰. 각 항목: { full, argsRaw, index, length }
function findSnippetMatches(text) {
    const out = []
    if (!text) return out
    const re = snippetRe()
    let m
    while ((m = re.exec(text)) !== null) {
        if (m.index === re.lastIndex) { re.lastIndex++; continue }
        out.push({
            full: m[0],
            argsRaw: m[1] || '',
            index: m.index,
            length: m[0].length,
        })
    }
    return out
}

// 'default="담당자" foo="bar"' → { default: '담당자', foo: 'bar' }
function parseKwargs(kwargsRaw) {
    const out = {}
    if (!kwargsRaw) return out
    const re = kwargRe()
    let m
    while ((m = re.exec(kwargsRaw)) !== null) {
        out[m[1]] = m[2]
    }
    return out
}

function hasVarToken(text) {
    return !!text && varRe().test(text)
}
function hasSnippetToken(text) {
    return !!text && snippetRe().test(text)
}
function hasAnyToken(text) {
    return hasVarToken(text) || hasSnippetToken(text)
}

module.exports = {
    // 정규식 팩토리(상태 격리)
    snippetRe,
    varRe,
    kwargRe,
    // 순수 헬퍼
    findVarMatches,
    findSnippetMatches,
    parseKwargs,
    hasVarToken,
    hasSnippetToken,
    hasAnyToken,
}
